module.exports = __webpack_public_path__ + "static/media/beach.d386fc77.mp4";